// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3f81Q","Home__Welcome":"Home_Home__Welcome__2mEvE","Home__Navigate":"Home_Home__Navigate__2KCZX","Home__Buttons":"Home_Home__Buttons__2UA6z"};